(ns frontend.view.components.timeline.entry.attachment-uploaded
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.entry.utils :as utils]
            [common.localization :as loc]))

(defn title-generator [{audit-op :audit/op :as entry}]
  (->> entry
       :audit/target-changes
       :common/attachments
       :add
       (first)
       :attachment/filename
       vector
       (loc/tr audit-op)))

(defmethod te/timeline-entry-view :op.attachment/upload [{entry :entry :as arg}]
  [default/timeline-item-view entry title-generator default/body-generator default/timestamp-generator])
